<template>
<svg viewBox="0 0 25 25" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-SheDeng`]" width="1em" height="1em" v-bind="$attrs"><path d="M22.6516 15.3836L10.2766 22.5086C9.90161 22.7336 9.45161 22.5836 9.26411 22.2461C9.03911 21.8711 9.18911 21.4211 9.52661 21.2336L10.2766 20.7836L6.90161 14.9336C5.28911 12.1211 6.03911 8.59609 8.55161 6.68359L6.45161 3.12109H2.77661C2.36411 3.12109 2.02661 2.78359 2.02661 2.37109C2.02661 1.95859 2.36411 1.62109 2.77661 1.62109H12.1516C12.5641 1.62109 12.9016 1.95859 12.9016 2.37109C12.9016 2.78359 12.5641 3.12109 12.1516 3.12109H8.21411L9.86411 5.93359C12.7891 4.62109 16.3141 5.74609 17.9641 8.59609L21.3391 14.4461L21.9016 14.1086C22.2766 13.8836 22.7266 14.0336 22.9141 14.3711C23.1391 14.7461 22.9891 15.1961 22.6516 15.3836ZM16.6516 9.30859C15.4141 7.17109 12.8266 6.34609 10.6141 7.20859L12.3766 10.2086C12.6016 10.5461 12.4516 11.0336 12.1141 11.2211C11.7391 11.4086 11.2891 11.2961 11.1016 10.9586L9.33911 7.95859C7.53911 9.45859 6.97661 12.0461 8.21411 14.1461L11.5891 19.9961L20.0266 15.1211L16.6516 9.30859Z"/></svg>
</template>
<script>

export default {
  name: 'IconSheDeng',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
